import { useTheme } from '@mui/material/styles';

export const FooterStyles = () => {
    const theme = useTheme();

    return {
            width: "100%",
            background: theme.palette.purpleCold.light,
            marginTop: "32px",
        "& .BoxStyles": {
            position: "relative",
            flexGrow: 1,
            display: "flex",
            justifyContent: "flex-start",
            padding: "10px",
            "& .version-control": {
                background: `${theme.palette.primary.light}1a`,
                borderRadius: '10px',
                padding: '0 8px',
                marginRight: '10px'
            }
        },
        "& .LinkButton": {
            color: theme.palette.primary.main,
            marginBottom: 0,
            marginTop: "8px",
            textDecoration: "none",
            fontSize:"medium",
            textTransform: "uppercase",
        },
    }
}
